import { useRef, useEffect } from 'react';
import { DateService } from './DateService';

/**
 * Reusable hook for managing a V2DateInput field within a useForm context.
 */
const useDateField = (form: any, fieldName: string) => {
  const invalidRef = useRef(false);

  // When the field value changes externally (e.g. form reset / discard),
  // sync invalidRef with the actual current value so stale invalid state is cleared.
  const watchedValue = form.watch(fieldName);
  useEffect(() => {
    if (!watchedValue || DateService.IsValidV2Date(watchedValue)) {
      invalidRef.current = false;
      form.clearErrors(fieldName);
    }
  }, [watchedValue]);

  const onChange = (e: any) => {
    const date: string = e?.target?.value ?? '';
    form.setValue(fieldName, date, { shouldDirty: true });

    if (!date) {
      // Cleared
      invalidRef.current = false;
      form.clearErrors(fieldName);
      return;
    }

    if (DateService.IsValidV2Date(date)) {
      invalidRef.current = false;
      form.clearErrors(fieldName);
    } else {
      // Partial or invalid date
      invalidRef.current = true;
      form.setError(fieldName, {
        type: 'manual',
        message: 'Please enter a valid date',
      });
    }
  };

  return {
    onChange,
    hasInvalidDate: () => invalidRef.current,
    fromApiDate: DateService.FromApiDate,
    toApiDate: DateService.ToApiDate,
  };
};

export { useDateField };
